import TourPageCategoryTile from 'components/Tours/TourPageCategoryTile'
import { useAppSelector } from 'hooks/reduxHooks'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import { formatCurrency } from 'lib/format/formatCurrencyIntl'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import config from 'constants/config'

interface Props {
  category: App.Tours.CategoryData
}

function TourPageTailorMadeTourCategoryTile(props: Props) {
  const tailorMadeTour = useTailorMadeTour()
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const currency = useAppSelector(state => state.geo.currentCurrency)
  const intl = useIntl()
  const { category } = props

  const subTextWithDeposit = intl.formatMessage(
    {
      id: 'hB43XwYx+m',
      defaultMessage: 'Crafted specifically for you with just a {formattedDeposit} deposit',
      description: 'Tailor-made tour category tile subtitle with deposit amount',
    },
    { formattedDeposit: formatCurrency(tailorMadeTour.data?.fee ?? 0, currency, region) },
  )

  const subTextWithoutDeposit = intl.formatMessage({
    id: 'KM22WQLOEU',
    defaultMessage: 'Crafted specifically for you',
    description: 'Tailor-made tour category tile subtitle without deposit amount',
  })

  const categoryUpdated = useMemo(() => {
    return {
      ...category,
      subText: tailorMadeTour.data?.fee ? subTextWithDeposit : subTextWithoutDeposit,
    }
  }, [category, tailorMadeTour.data?.fee, subTextWithDeposit, subTextWithoutDeposit])

  const enableFeature = useMemo(() => {
    return config.TAILOR_MADE_TOURS_REGIONS && isEnabledForFeature(config.TAILOR_MADE_TOURS_REGIONS, region)
  }, [region])

  const requestText = intl.formatMessage(
    {
      id: 'jauFPIYFx5',
      defaultMessage: 'Request',
      description: 'Button text to request a tailor-made tour',
    },
  )

  if (!enableFeature) {
    return null
  }
  return <TourPageCategoryTile
    actionText={requestText}
    toUrl="/campaign/tailor-made-tours"
    category={categoryUpdated}
  />
}

export default TourPageTailorMadeTourCategoryTile
